import { NAME_REGEX } from '../../Auth/Register/Components/regex';

export const nameInputValidation = (value) => {
    let val = value.replace(/[^A-Za-z ]/g, "");
    if (val.length === 1 && val[0] === ' ') val = '';
    return val.slice(0, 100);
}

export const isValidName = val => NAME_REGEX.test(val.trim()) && !/^\s/.test(val) && val.trim().length > 0;

export const validateName = (name) => {
    if (!name) {
        return { message: "Name is required", valid: false };
    } else if (/^\s/.test(name)) {
        return { message: "Name should not start with a space", valid: false };
    } else if (name.length > 30) {
        return { message: "Name should not exceed 100 characters", valid: false };
    } else if (!isValidName(name)) {
        return { message: "Name must contain only alphabets", valid: false };
    } else {
        return { message: "", valid: true };
    }
}